import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from "rxjs";
import {Uuid} from "../interface/response/uuid";
import {first, take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ReceivablesPaymentImport} from "../interface/receivables-payment-import";
import {ReceivablesImport} from "../interface/receivables-import";

@Injectable({
  providedIn: 'root'
})
export class ReceivablesPaymentImportService {
  public readonly importListSubject: ReplaySubject<CountedAndPaginated<ReceivablesPaymentImport>>
    = new ReplaySubject<CountedAndPaginated<ReceivablesPaymentImport>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public import(formData: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/receivables-payment-import`, formData)
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  public loadImportList(page: number, pageSize: number, filters: object, subject?: Subject<CountedAndPaginated<ReceivablesPaymentImport>>): void {
    this.httpClient.get(`/rest/crm/receivables-payment-import?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ReceivablesPaymentImport>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.importListSubject.next(result);
        }
      });
  }

  public deleteImport(uuid: string): Observable<Uuid>  {
    return this.httpClient.delete(`/rest/crm/receivables-payment-import/${uuid}`)
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadImportFile(importId: string): void {
    this.document.location.href = `/rest/crm/receivables-payment-import/${importId}/downloadFile`;
  }
}
